module.exports = __webpack_public_path__ + "img/Temperature Icon - white.b31d2766.svg";